import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  postOrders: []
};

const postOrdersSlice = createSlice({
  name: 'postOrders',
  initialState,
  reducers: {
    add(state, action) {
      const { postOrder } = action.payload;
      state.postOrders.push(postOrder);
    },
    remove(state, action) {
      const { index } = action.payload;
      state.postOrders = state.postOrders.filter((postOrder, filterIndex) => filterIndex !== index);
    },
    init(state, action) {
      const { postOrders } = action.payload;
      state.postOrders = postOrders;
    },
    update(state, action) {
      const { index, postOrder } = action.payload;
      state.postOrders[index] = postOrder;
    }
  }
});

export const {
  add,
  remove,
  init,
  update
} = postOrdersSlice.actions;

export default postOrdersSlice.reducer;